module.exports = __webpack_public_path__ + "img/SketchPngb933c4810e22c77582a0d14344830e017bc0c382ecd9f4767c24ea7f54193cab.c3725162.png";